import { css, SerializedStyles } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';

export const navigationContainer = css`
  position: sticky;
  top: 18px;
  padding-left: 18px;
  ${media('>=tablet')} {
    max-height: calc(100vh - 50px);
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

export const navMenu = css`
  display: block;
  white-space: nowrap;
  vertical-align: middle;
  margin-top: 6px;
`;

export const navMenuItem = css`
  display: block;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  margin-top: 6px;
`;

export const icon = css`
  display: inline-block;
  position: absolute;
  left: -18px;
  top: 0px;
  width: 16px;
  height: 16px;
`;

export const navigationTitle = css`
  font-weight: 700;
  ${media('>=tablet')} {
    display: none;
  }
`;

// only indent this iif the parent is a menu
export const subNavMenu = (underNavHeading: boolean): SerializedStyles => css`
  margin-left: ${underNavHeading ? '0' : '10'}px;
`;

export const subNavHeading = css`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 16px;
`;

export const navLink = (
  isSelected: boolean,
  hasIcon: boolean,
): SerializedStyles => css`
  width: 100%;
  height: 100%;
  font-weight: 400;
  font-size: 16px;
  ${isSelected &&
  `
    font-weight: 600;
    background-color: ${variables.colour.neutral200};
  `}
  ${hasIcon &&
  `
    margin-left: 0px;
  `}
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  color: ${variables.colour.neutral700};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
  vertical-align: middle;
  i {
    vertical-align: top;
    color: ${variables.colour.neutral500};
  }
`;
